/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var DirectivesTranslations = /** @class */ (function () {
        function DirectivesTranslations() {
        }
        DirectivesTranslations.config = function ($translateProvider) {
            var _a;
            var keys = ap.Constants.translationKeys.directives;
            $translateProvider.translations('en', (_a = {}, _a[keys.loading] = 'Loading...', _a));
        };
        return DirectivesTranslations;
    }());
    app.DirectivesTranslations = DirectivesTranslations;
    angular.module('app')
        .config(['$translateProvider', DirectivesTranslations.config]);
})(app || (app = {}));
